/** @format */

import { Col, Layout, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { UIInput } from "../../ui/Input";
import { BarcodeOutlined, SearchOutlined } from "@ant-design/icons";
import { UIButton } from "../../ui/Button";
import { UIText } from "../../ui/Text";
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import apiClient from "../../../utils/apiClient";
import { API_TASKS } from "../../../constants/api";
import qs from "qs";
import { UITitle } from "../../ui/Title";
import { Colors } from "../../../theme/maps/Colors";
import { NavLink } from "react-router-dom";
import { Routes } from "../../../utils/Routes";

export const ViewSearch = (): JSX.Element => {
  const [barCode, setBarCode] = useState("");
  const [research, setResearch] = useState("");
  const [userList, setUserList] = useState([]);
  const [currentUserList, setCurrentUserList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [result, setResult] = useState({});

  const showModal = (): void => setIsModalVisible(true);
  const handleOk = (): void => setIsModalVisible(false);
  const handleCancel = (): void => setIsModalVisible(false);

  const handleSearch = (research: string): void => {
    // eslint-disable-next-line array-callback-return
    const current = userList.filter(el => {
      //@ts-ignore
      if (el["ragione_sociale"].toLowerCase().includes(research.toLowerCase())) return el;
    });
    setCurrentUserList(current);
  };

  const handleBarCode = (barCode: string): void => {
    apiClient
      .post(
        "",
        qs.stringify({
          task: API_TASKS.GET_CODICE_AZIENDA,
          barcode: barCode,
        }),
      )
      .then(res => {
        setResult(res.data);
      })
      .catch(er => {
        setResult(
          JSON.parse('{"ESITO":"OK","ID_CLIENTE":"36","ID_CARD":"28","RAGSOC":"BRUGNANO S.R.L."}'),
        );
      });
  };

  useEffect(() => {
    if (barCode !== "") handleBarCode(barCode);
  }, [barCode]);

  useEffect(() => {
    if (research !== "") handleSearch(research);
  }, [research]);

  useEffect(() => {
    apiClient
      .post(
        "",
        qs.stringify({
          task: API_TASKS.GET_SEARCH,
        }),
      )
      .then(res => {
        setUserList(res.data.CLIENTI);
      })
      .catch(er => {
        setUserList(
          JSON.parse(
            '{"ESITO":"OK","CLIENTI":[{"id":"51","ragione_sociale":"NORD ELEVATORS S.R.L"},{"id":"12","ragione_sociale":"Centro medico di ortopedia e Fisiokinesiterapia S.r.l."},{"id":"53","ragione_sociale":"CO.GE.SI"},{"id":"52","ragione_sociale":"LUNETTO "},{"id":"10","ragione_sociale":"Cucinella Giuseppe s.r.l."},{"id":"13","ragione_sociale":"Chimica Noto S.r.l. "},{"id":"48","ragione_sociale":"BADALAMENTI"},{"id":"16","ragione_sociale":"NUOVA EDIL STRADALE S.A.S"},{"id":"17","ragione_sociale":"ISTITUTO DI VIGILANZA EUROPOL S.R.L."},{"id":"18","ragione_sociale":"LA FENICE S.R.L"},{"id":"20","ragione_sociale":"Costruzione Tonnino Giovanni Battista"},{"id":"22","ragione_sociale":"TOAN DI ZITO SALVATORE"},{"id":"23","ragione_sociale":"METAL COSTRUZIONI S.R.L."},{"id":"24","ragione_sociale":"Jcom Telecomunicazioni s.c.a.r.l."},{"id":"25","ragione_sociale":"Chiovaroto Tito"},{"id":"26","ragione_sociale":"BALDARI IMPIANTI S.R.L.S."},{"id":"27","ragione_sociale":"Due F. Trasporti di Farnese F. & C. s.n.c."},{"id":"28","ragione_sociale":"Sciara Stefano"},{"id":"30","ragione_sociale":"SCIANNA"},{"id":"31","ragione_sociale":"PROTEZIONE CIVILE"},{"id":"32","ragione_sociale":"ALECCIA VINCENZO"},{"id":"33","ragione_sociale":"SCIARA GAETANO"},{"id":"35","ragione_sociale":"BENNY ANGELO BLU"},{"id":"36","ragione_sociale":"BRUGNANO S.R.L."},{"id":"49","ragione_sociale":"GIDA s.r.l. "},{"id":"50","ragione_sociale":"CARGO "},{"id":"38","ragione_sociale":"SALUS"},{"id":"47","ragione_sociale":"ORTOSUD DI LOMBARDO"},{"id":"60","ragione_sociale":"NUOVA LUNA "},{"id":"59","ragione_sociale":"INOX"},{"id":"42","ragione_sociale":"CONSORZIO SOCIALE SERVIZI QUALIFICATI ONLUS"},{"id":"56","ragione_sociale":"CORSO VINCENZO"},{"id":"58","ragione_sociale":"CAVA GALATI"},{"id":"54","ragione_sociale":"MONDIALPOL"},{"id":"55","ragione_sociale":"PALAZZOLO COSTRUZIONI"},{"id":"44","ragione_sociale":"CONSORZIO HERA SOCIETA COOPERATIVA SOCIALE ONLUS"},{"id":"57","ragione_sociale":"TIMPA GIANFRANCO"},{"id":"61","ragione_sociale":"RS RAPPA TRASPORTI"},{"id":"62","ragione_sociale":"CS POLICE "},{"id":"63","ragione_sociale":"lo monaco costruzioni "},{"id":"64","ragione_sociale":"TRUE SERVICE"},{"id":"65","ragione_sociale":"BARRETTA PASQUALE "},{"id":"66","ragione_sociale":"CENTRO ORTOPEDICO SANIATRIO FERRO S.A.S"},{"id":"67","ragione_sociale":"PECORELLA GASPARE "},{"id":"68","ragione_sociale":"CRI.MAR"},{"id":"69","ragione_sociale":"DS SERVICE SRL "},{"id":"70","ragione_sociale":"TECNOSYSTEM SRL "}]}',
          ).CLIENTI,
        );
      });
  }, []);
  return (
    <>
      <Layout style={{ padding: "0", height: "100%" }}>
        <Row
          justify="center"
          style={{
            backgroundColor: Colors.background,
          }}
        >
          <Col span={3} style={{ padding: "5px", textAlign: "center" }}>
            <NavLink to={Routes.home}>
              <UITitle level={3} style={{ margin: 0, fontWeight: "bold" }}>
                {"<"}
              </UITitle>
            </NavLink>
          </Col>
          <Col span={18} style={{ padding: "5px", textAlign: "center" }}>
            <UITitle level={4} style={{ margin: 0, fontWeight: "bold" }}>
              CLIENTE
            </UITitle>
          </Col>
          <Col span={3}></Col>
        </Row>
        <Row style={{ padding: "0 5px", marginTop: "10px" }}>
          <Col span={17} style={{ padding: "0 5px" }}>
            <UIInput
              placeholder="Ragione Sociale"
              prefix={<SearchOutlined />}
              style={{ height: "45px" }}
              value={research}
              onChange={(e): void => {
                setResearch(e.target.value);
              }}
            />
          </Col>
          <Col span={7} style={{ padding: "0 5px 0 0" }}>
            <UIButton fullWidth style={{ height: "45px" }} onClick={showModal}>
              <BarcodeOutlined />
              <UIText>Scan</UIText>
            </UIButton>
          </Col>
        </Row>
        {!!currentUserList.length &&
          currentUserList.map(el => (
            <NavLink
              //@ts-ignore
              to={Routes.form.replace(":idCliente", el.id) + "?l=" + Date.now()}
              //@ts-ignore
              key={el.id}
            >
              <Row
                justify="center"
                style={{
                  paddingTop: "5px",
                  backgroundColor: Colors.white,
                  borderBottom: "2px solid " + Colors.background,
                }}
              >
                <Col style={{ padding: "12px" }}>
                  <UITitle noWrap level={5} style={{ margin: 0, fontWeight: 800 }}>
                    {
                      //@ts-ignore
                      el.ragione_sociale
                    }
                  </UITitle>
                </Col>
              </Row>
            </NavLink>
          ))}
        {result &&
          //@ts-ignore
          result.ID_CLIENTE && (
            //@ts-ignore
            <NavLink to={Routes.form.replace(":idCliente", result.ID_CLIENTE)}>
              <Row
                justify="center"
                style={{
                  marginTop: "5px",
                  backgroundColor: Colors.white,
                  borderBottom: "2px solid " + Colors.background,
                }}
              >
                <Col style={{ padding: "12px" }}>
                  <UITitle level={3}>
                    {
                      //@ts-ignore
                      result.RAGSOC
                    }
                  </UITitle>
                </Col>
              </Row>
            </NavLink>
          )}
      </Layout>
      <Modal
        title="BARCODE SCANNER"
        visible={isModalVisible}
        //onOk={handleOk}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={handleCancel}
      >
        {isModalVisible && (
          <BarcodeScannerComponent
            //@ts-ignore
            width={"100%"}
            //@ts-ignore
            height={"100%"}
            onUpdate={(err, result): void => {
              if (result) {
                //@ts-ignore
                setBarCode(result.text);
                handleOk();
              }
            }}
          />
        )}
      </Modal>
    </>
  );
};
